import { render, staticRenderFns } from "./OccupancyFeeReceiptsPaymentsDetail.vue?vue&type=template&id=2c7290ca&scoped=true"
import script from "./OccupancyFeeReceiptsPaymentsDetail.vue?vue&type=script&lang=js"
export * from "./OccupancyFeeReceiptsPaymentsDetail.vue?vue&type=script&lang=js"
import style0 from "./OccupancyFeeReceiptsPaymentsDetail.vue?vue&type=style&index=0&id=2c7290ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c7290ca",
  null
  
)

export default component.exports